<template>
    <div>
        <div class="row">
            <div class="col-md-3">
                <card v-if="tree">
                    <collapse :multiple-active="false" :active-index="0">
                        <collapse-item :title="`Volume ${vol.volume}`" v-for="(vol) in tree" :key="`vol${vol.volume}`">
                            <ul class="issues-list">
                                <!-- <router-link class="nav-item" tag="li" :to="`/www/glimpses/home/${vol.volume}/${issue}`" v-for="(issue) in vol.issues" :key="`vol${vol.volume}issue${issue}`"> -->
                                    <a class="nav-link" :href="`/www/glimpses/home/${vol.volume}/${issue}`" v-for="(issue) in vol.issues" :key="`vol${vol.volume}issue${issue}`">Issue {{ issue }}</a>
                                <!-- </router-link> -->
                            </ul>
                        </collapse-item>
                    </collapse>
                </card>
            </div>
            <div class="col-md-9">
                <card card-body-classes="" no-footer-line v-if="news">
                    <div slot="header">
                        <h4  class="title title-up mt-2 mb-0">{{ news.title }}</h4>
                        <p class="text-muted">{{ date }} | {{ news.author.name }}</p>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <img :src="news.image" alt="" style="width: 100%">
                        </div>
                        <div class="col-12 mt-4">
                            <p v-html="news.long_description"></p>
                        </div>
                    </div>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import { Card, NewsCard, PreviewCard, NewsletterCard, Collapse, CollapseItem } from 'src/components';
import { mapGetters } from 'vuex';

export default {
    name: 'Home',
    components:{
        Card,
        PreviewCard,
        NewsCard,
        NewsletterCard,
        Collapse,
        CollapseItem
    },
    data(){
        return {
            // volumes: [
            //     {
            //         number: 1,
            //         issues: [1, 2, 3, 4, 5, 6]
            //     },
            //     {
            //         number: 2,
            //         issues: [1, 2, 3, 4, 5, 6]
            //     }
            // ]
        }
    },
    mounted(){
        this.$store.dispatch('getNewsletterTree')
        this.$store.dispatch('getNew', this.$route.params.slug)
    },
    computed: {
        ...mapGetters({
            authTokens: 'getAuthTokens',
            news: 'getNew',
            tree: 'getNewsletterTree'
        }),
        date: function(){
            if(this.news){
                let date = new Date(this.news.date)
                return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
            }
            else{
                return ''
            }
        },
    },
    methods: {
    }
}
</script>

<style lang="scss">
    .issues-list{
        list-style-type: none;
        padding-left: 0;
    }
</style>
